import { render } from "./OneOnOneListSkeletonCard.vue?vue&type=template&id=14873658&scoped=true"
import script from "./OneOnOneListSkeletonCard.vue?vue&type=script&lang=js"
export * from "./OneOnOneListSkeletonCard.vue?vue&type=script&lang=js"

import "./OneOnOneListSkeletonCard.vue?vue&type=style&index=0&id=14873658&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14873658"

export default script